export interface CustomLabel {
  custom_label_id: string;
  type: string;
  index: number;
  label: string;
}

export enum CustomLabelType {
  TARGET_ACHIEVEMENT_TIME_EPA = "TARGET_ACHIEVEMENT_TIME_EPA",
  TARGET_ACHIEVEMENT_TIME_COMPETENCY = "TARGET_ACHIEVEMENT_TIME_COMPETENCY",
  SKILL_LEVEL_SCORE_EPA = "SKILL_LEVEL_SCORE",
  SKILL_LEVEL_SCORE_COMPETENCY = "SKILL_LEVEL_SCORE_COMPETENCY",
}
